export default __webpack_public_path__ + "static/media/add.2af29faa.svg";